import './index.css'
import React from 'react';
import SimpleEditor from '../common/SimpleEditor';
import { CompanyForm } from '../../models/company.model';


interface DescriptionProps {
  action: string;
  companyForm: CompanyForm;
  handleChange?: (e: any) => void
}

const Description: React.FC<DescriptionProps> = ({ action, companyForm, handleChange }) => {

  return (
    <React.Fragment>
      <div className='company-form-section'>
        <div className='company-form-section-title'>
          <p>DESCRIPCIÓN</p>
        </div>

        <div className='company-form-section-item__desc'>
          <SimpleEditor
            name='description'
            value={companyForm.description}
            handleChange={handleChange}
            disabled={action === 'view'}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

export default Description;